import type {Part} from 'schemaDefinition/types';
import {usePreviewConfigurationContext} from '../contexts';
import {isPartExcluded} from '../functions';

export const useIsPartExcluded = (part?: Part): boolean => {
  const config = usePreviewConfigurationContext();
  return isPartExcluded(part, config);
};
